import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum AccountsTableColumn {
    ENTITY_OR_ACCOUNT = "entityOrAccount",
    ACCOUNT_TYPE = "accountType",
    TEAM = "team",
    STATUS = "status",
    BALANCE = "balance",
    ACTIONS = "actions",
}

const EntityOrAccountColumnSchema = ColumnSchema.extend({
    id: z.literal(AccountsTableColumn.ENTITY_OR_ACCOUNT),
});
export type EntityOrAccountColumn = z.infer<typeof EntityOrAccountColumnSchema>;

const TeamColumnSchema = ColumnSchema.extend({
    id: z.literal(AccountsTableColumn.TEAM),
});
export type TeamColumn = z.infer<typeof TeamColumnSchema>;

const AccountTypeColumnSchema = ColumnSchema.extend({
    id: z.literal(AccountsTableColumn.ACCOUNT_TYPE),
});
export type AccountTypeColumn = z.infer<typeof AccountTypeColumnSchema>;

const StatusColumnSchema = ColumnSchema.extend({
    id: z.literal(AccountsTableColumn.STATUS),
});
export type StatusColumn = z.infer<typeof StatusColumnSchema>;

const BalanceColumnSchema = ColumnSchema.extend({
    id: z.literal(AccountsTableColumn.BALANCE),
});
export type BalanceColumn = z.infer<typeof BalanceColumnSchema>;

const ActionsColumnSchema = ColumnSchema.extend({
    id: z.literal(AccountsTableColumn.ACTIONS),
});
export type ActionsColumn = z.infer<typeof ActionsColumnSchema>;

export const AccountsViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.ACCOUNTS),
    columns: z.array(
        z.discriminatedUnion("id", [
            EntityOrAccountColumnSchema,
            TeamColumnSchema,
            AccountTypeColumnSchema,
            StatusColumnSchema,
            BalanceColumnSchema,
            ActionsColumnSchema,
        ]),
    ),
});

export type AccountsView = z.infer<typeof AccountsViewSchema>;
